import { Component } from '@angular/core';

import type { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/core';

import { cn } from '@valk-nx/core/lib/core';

@Component({
	selector: 'formly-field-heading',
	template: `
		<span
			[class]="
				cn('block text-2xl font-semibold', {
					'text-center': props['alignment'] === 'center',
					'text-left': props['alignment'] === 'left',
					'mb-4': props['gapSize'] === 'small',
					'mb-6': props['gapSize'] === 'large',
				})
			"
			data-test-class="form-field-heading"
		>
			{{ props.label | translate }}
		</span>
	`,
	standalone: false,
})
export class HeadingComponent extends FieldType<FieldTypeConfig> {
	cn = cn;
}
